<template>
  <div
    class="d-flex-column justify-start align-start"
    :class="[steps.length > 0 && 'gap-24']"
  >
    <div class="d-flex-row gap-0">
      <div class="range-slider">
        <div class="progress" ref="progress"></div>
        <input
          type="range"
          :min="min"
          :max="max"
          v-model="sliderMin"
          class="left"
          :step="step"
        />
        <input
          type="range"
          :min="maxOfMaximum"
          :max="max"
          v-model="sliderMax"
          :step="step"
          ref="sliderMaxInput"
        />
      </div>
    </div>

    <div class="d-flex-row space-between" v-if="steps.length > 0">
      <label
        class="t-white medium-xl font-family-2"
        v-for="(step, index) in steps"
        :key="step"
        :class="[index === 0 || index === steps.length - 1 ? '' : 'md-hide']"
        >{{ step.title }}</label
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderMin: 0,
      sliderMax: 70,
      gap: 10,
    };
  },
  props: {
    steps: {
      default: [
        {
          title: "1k",
        },
        {
          title: "10k",
        },
        {
          title: "20k",
        },
        {
          title: "30k",
        },
        {
          title: "40k",
        },
        {
          title: "50k",
        },
        {
          title: "60k",
        },
      ],
    },
    min: {
      default: 1,
    },
    max: {
      default: 10,
    },

    modelValue: {
      default: null,
    },
    step: {
      default: 1,
    },
    minimumMax: {
      default: null,
    },
  },
  beforeMount() {
    this.sliderMin = this.modelValue?.min || this.min;
    this.sliderMax = this.modelValue?.max || this.max;
  },
  computed: {
    maxOfMaximum() {
      if (this.maximumMax) {
        return this.maxOfMaximum;
      }
      return this.min;
    },
  },
  watch: {
    sliderMin(val) {
      const value = parseInt(this.sliderMin);
      if (value >= this.sliderMax) {
        this.sliderMin = this.sliderMax - 50;
        return;
      }
      if (this.$refs?.progress?.style) {
        this.$refs.progress.style.left = (value / this.max) * 100 + "%";
      }

      if (this.modelValue?.min !== value) {
        this.$emit("update:modelValue", {
          min: parseInt(val),
          max: parseInt(this.sliderMax),
        });
      }
    },
    sliderMax(val) {
      const value = parseInt(this.sliderMax);
      if (value < this.sliderMin + 50) {
        this.sliderMax = this.sliderMin - 50;
        return;
      }
      if (this.$refs?.progress?.style) {
        this.$refs.progress.style.right = 100 - (value / this.max) * 100 + "%";
      }

      if (this.modelValue?.max !== value) {
        this.$emit("update:modelValue", {
          max: value,
          min: parseInt(this.sliderMin),
        });
      }
    },

    modelValue: {
      handler() {
        if (this.modelValue !== null) {
          // HANDLING MINIMUM CONTROL POINT
          if (this.modelValue?.min !== this.sliderMin) {
            this.sliderMin = this.modelValue?.min || this.min;
          }
          // HANDLING MAXIMUM CONTROL POINT
          if (this.modelValue?.max !== this.sliderMax) {
            this.sliderMax = this.modelValue?.max || this.max;

            this.$nextTick(() => {
              if (this.$refs?.sliderMaxInput) {
                this.$refs.sliderMaxInput.value = this.sliderMax;
              }
            });
          }
        }
      },
      deep: true,
    },
    max(val) {
      // this.$refs.progress.style.right = 100 - (this.max / this.max) * 100 + "%";
      // if (this.sliderMax < val) {
      //   if (this.$refs?.sliderMaxInput) {
      //     this.sliderMax = this.max;
      //     this.$refs.sliderMaxInput.value = 48;
      //     console.log(this.$refs.sliderMaxInput.value);
      //   }
      // }
    },
  },
};
</script>
